// removed by extract-text-webpack-plugin
module.exports = {"active":"_3IN09T37","content":"_7VQL1Gda","toolbar":"_5PGxIq73","logo":"_3gwMQlda","signout":"_3QYnaZYr"};


//////////////////
// WEBPACK FOOTER
// ./app/customers/components/sidenav/sidenav.styles.scss
// module id = 506
// module chunks = 0